module.exports = __webpack_public_path__ + "img/C vd Houtstr voor.b8b3eebb.jpg";